<template>
    <div>
        <v-dialog v-model="dialog_form" content-class="half-screen-dialog" no-click-animation scrollable persistent transition="slide-y-transition" :max-width="$root.fn_getActionPaneWidth()">
            <v-card no-border-radius grey-back>

              <v-toolbar :height="56" flat>
                  <v-btn icon @click="closeDialog"><v-icon>arrow_back</v-icon></v-btn>
                  <v-toolbar-title>
                    Bill of Materials
                  </v-toolbar-title>
              </v-toolbar>

              <v-divider class="noprint"></v-divider>

              <div class="data-container grey-back">

                <v-progress-linear indeterminate :height="6" color="primary" v-if="$root.dialogLoader || $parent.loading"></v-progress-linear>
                <div center-align class="pa-4 light-opacity-color" v-if="$root.dialogLoader">Syncing master items...</div>

                <div center-align class="pa-4" v-if="$parent.cacheRetry">
                  <v-btn color="primary" capitalize text @click="$parent.fn_resetCache"><v-icon class="mr-2">refresh</v-icon> Reload</v-btn>
                </div>

                <template>
                  <!-- <v-subheader class="mb-2" white-back>Date
                    <v-spacer></v-spacer>
                    <span><u>{{$parent.Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</u></span>
                  </v-subheader> -->

                  <!-- <v-list class="pa-0">
                        <v-list-item style="height:36px">
                            <v-list-item-content>
                              <v-list-item-title>{{$parent.Form.transactionData.mergeTransactionNumber}}</v-list-item-title>
                            </v-list-item-content>

                            <span v-if="$parent.Form.transactionData.transactionDate">{{$parent.Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span> 

                            <v-list-item-action class="ml-0">
                                <v-btn icon @click="$parent.fn_openDatePicker('transactionDate', $parent.Form.transactionData.transactionDate)"><v-icon>date_range</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list> -->

                    <v-list class="pa-0">
                        <v-list-item style="height:36px">
                            <v-list-item-content>
                              <v-list-item-title>
                                  <span cursor-pointer class="text-underline" @click="$parent.fn_openDialogNumberSeries">{{$parent.Form.transactionData.mergeTransactionNumber}}</span>
                              </v-list-item-title>
                            </v-list-item-content>

                            <span v-if="$parent.Form.transactionData.transactionDate">{{$parent.Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span> 

                            <v-list-item-action class="ml-0">
                                <v-btn icon @click="$parent.fn_openDatePicker('transactionDate', $parent.Form.transactionData.transactionDate)"><v-icon>date_range</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>

                  <ValidationObserver ref="observer">

                      <v-form>

                    

                        <v-layout row wrap ma-0 white-back pt-4 pb-4>
                              <v-flex xs12 sm12 md12 form-item pt-4>
                                <ValidationProvider name="Item" rules="required" v-slot="{ errors }">
                                    
                                    <v-autocomplete
                                        :items="$parent.filteredProducts ? $parent.filteredProducts : []"
                                        v-model="$parent.Form.selectedProduct"
                                        @input="$parent.fn_getProductData($parent.Form.selectedProduct.itemId);"
                                        label="Product"
                                        placeholder=" "
                                        item-text="itemName"
                                        item-value="itemId"
                                        return-object
                                        required
                                        :error-messages="errors"
                                        dense
                                        append>

                                        <v-list-item slot="prepend-item" class="primary--text" @click="$parent.fn_menuItemClick('newproduct')">
                                            <v-list-item-title>Create New</v-list-item-title>
                                        </v-list-item>
                                    </v-autocomplete>

                                    <div class="pt-2 font12 right-align" v-if="$parent.Form.summaryArray.length">
                                      <template v-for="(item, index) in $parent.Form.summaryArray">
                                          <span :key="index">
                                            {{item.unitName}}: <span :class="[item.qty < 0 ? 'redcolor' : 'greencolor']">{{item.roundOffQty}}</span>
                                          </span>
                                      </template>
                                    </div>
                                    
                                </ValidationProvider>
                              </v-flex>

                              <v-flex xs12 sm12 md12 form-item>
                                <ValidationProvider name="Qty" rules="required|decimal3" v-slot="{ errors }">
                                  <v-text-field 
                                      :disabled="$parent.Form.productBatches && $parent.Form.productBatches.length ? true : false"
                                      v-model="$parent.Form.qty"
                                      @input="$parent.fn_calculateBomProductsAmount"
                                      label="Qty" 
                                      placeholder=" "
                                      type="number"
                                      :error-messages="errors"
                                      required>
                                  </v-text-field> 
                                </ValidationProvider>
                            </v-flex>

                        </v-layout>

                        <template v-if="$root.TransactionSettings.enableBatch">

                          <template v-if="$parent.hasSeries && !$parent.hasOnlySeries">
                            <v-radio-group class="pt-3 pl-3 pr-3 pb-3 nomargin white-back" white-background hide-details @change="$parent.fn_changeFormBatchType" v-model="$parent.Form.finishedGoodBatchType" row>
                              <v-radio label="Batch" :value="1"></v-radio>
                              <v-radio label="Series" :value="2"></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                          </template>

                          <v-subheader white-back>
                            <template v-if="$parent.Form.finishedGoodBatchType == 2"><span v-for="(field, index) in $parent.seriesFields" :key="field.title">{{ field.title }}<span v-if="$parent.seriesFields.length - 1 != index">/</span></span></template>
                            <template v-else>#Batches</template>
                            <v-spacer></v-spacer> 
                            <v-btn v-if="!$parent.Form.productBatches || !$parent.Form.productBatches.length" small text outlined capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogSelectBatch">
                              <v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
                            </v-btn>
                            <v-btn v-else small text outlined capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_removeBatch">
                              <v-icon class="mr-1" font16 color="primary">close</v-icon> Remove
                            </v-btn>
                          </v-subheader>

                          <div class="grey-back full-width batch_display_container" v-if="$parent.Form.productBatches && $parent.Form.productBatches.length">

                            <v-expansion-panels nomargin>

                              <v-expansion-panel>

                                <!-- <div slot="header" light-opacity-color font16 class="pt-0 pb-0">Batches#</div> -->
                                <v-expansion-panel-header>
                                    <template>
                                        <v-subheader dense class="pa-0">#Batches</v-subheader>
                                    </template>
                                </v-expansion-panel-header>
                                
                                <v-expansion-panel-content>
                                  <v-card flat v-for="(batch, batchIndex) in $parent.Form.productBatches" :key="batchIndex">

                                    <v-card-text class="pb-2 pt-2">
                                      <v-layout class="batch_layout ma-0" row wrap>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
                                          <div light-opacity-color>Batch No.</div>
                                          <div>{{ batch.batchNumber }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
                                          <div light-opacity-color>Size</div>
                                          <div>{{ batch.batchSize }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
                                          <div light-opacity-color>MRP</div>
                                          <div>{{ batch.batchMRP }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
                                          <div light-opacity-color>Mfg. Date</div>
                                          <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
                                          <div light-opacity-color>Exp. Date</div>
                                          <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                        </v-flex>
                                        <!-- <v-flex xs4 sm4 md4 mb-2>
                                          <div light-opacity-color>Opening</div>
                                          <div>{{ batch.opening ? batch.opening : 0  }}</div>
                                        </v-flex> -->
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
                                          <div light-opacity-color>Purchase Rate</div>
                                          <div>{{ batch.purchaseRate }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
                                          <div light-opacity-color>Serial Number</div>
                                          <div>{{ batch.field1 }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
                                          <div light-opacity-color>IMEI Number</div>
                                          <div>{{ batch.field2 }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
                                          <div light-opacity-color>Part Number</div>
                                          <div>{{ batch.field3 }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
                                          <div light-opacity-color>Model Number</div>
                                          <div>{{ batch.field4 }}</div>
                                        </v-flex>
                                        <v-flex xs4 sm4 md4 mb-2 v-if="$parent.Form.finishedGoodBatchType == 1 && ($parent.Form.productBatches.length > 1 || $parent.Form.productBatches.length == 1 && batch.productQty != $parent.Form.qty)">
                                          <div light-opacity-color>Quantity</div>
                                          <div>{{ batch.productQty }}</div>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
                                          <v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-divider v-if="$parent.Form.productBatches.length - 1 != batchIndex"></v-divider>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>

                            </v-expansion-panels>

                          </div>
                        </template>

                       <v-list two-line class="mt-2" nopadding v-if="$parent.Form.transactionProducts && $parent.Form.transactionProducts.length">
                        <v-subheader class="pr-0">Materials (Consumption)</v-subheader>
                        <div v-for="(item, index) in $parent.Form.transactionProducts" :key="index"> 
                            <v-divider :key="index+'divider'"></v-divider>                
                            
                            <div :key="'batch_subheader'+index">
                              <template v-if="$parent.hasSeries && !$parent.hasOnlySeries && $root.TransactionSettings.enableBatch && $parent.Form.qty">
                                <v-radio-group class="pt-3 pl-3 pr-3 pb-3 nomargin" white-background hide-details @change="item.selectedBatchType=$event" v-model="item.selectedBatchType" row>
                                  <v-radio label="Batch" :value="1"></v-radio>
                                  <v-radio label="Series" :value="2"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </template>

                              <v-subheader white-background v-if="$root.TransactionSettings.enableBatch">
                                <template v-if="item.selectedBatchType == 2"><span v-for="(field, index) in $parent.seriesFields" :key="field.title">{{ field.title }}<span v-if="$parent.seriesFields.length - 1 != index">/</span></span></template>
                                <template v-else>#Batches</template>
                                <v-spacer></v-spacer> 
                                <v-btn v-if="$parent.Form.qty" small text outlined capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_getBatches(item.productId, index)">
                                  <v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
                                </v-btn>  
                              </v-subheader>
                            </div>

                            <v-list-item :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.productName }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.qtySum }} {{ item.unitName }}</v-list-item-subtitle>
                                    <!-- <v-list-item-subtitle>
                      <v-text-field 
                        v-model.number="item.rate" 
                        @input="fn_calculateBomProductsAmount"  
                        type="number" 
                        label="">
                      </v-text-field>
                    </v-list-item-subtitle> -->
                                </v-list-item-content>
                                <!-- <v-list-item-action>
                                    {{ item.amount }}
                                </v-list-item-action> -->
                            </v-list-item>

                            <v-layout row ma-0 :key="index+'items'" wrap mb-2 pb-2>
                              <v-flex xs6 sm6 md6 form-item>
                                <div light-opacity-color font12>Rate (&#8377;)</div>
                                <ValidationProvider :name="item.productName + ' Rate'" rules="decimal2" v-slot="{ errors }">
                                  <input 
                                    style="width: 100%;
                                    padding: 5px;
                                    border: 1px solid;
                                    border-radius: 4px;
                                    border-color: rgba(0, 0, 0, 0.40);"
                                    type="number" 
                                    v-model.number="item.rate" 
                                    @input="$parent.fn_calculateBomProductsAmount">

                                    <div class="redcolor font12 pt-2" v-if="errors && errors.length">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  
                              </v-flex>

                              <v-flex xs6 sm6 md6 form-item>
                                <div light-opacity-color font12>Amount (&#8377;)</div>
                                <input 
                                  disabled
                                  style="width: 100%;
                                  padding: 5px;
                                  border: 1px solid;
                                  border-radius: 4px;
                                  border-color: rgba(0, 0, 0, 0.24); color:rgba(0, 0, 0, 0.40)"
                                  type="number" 
                                  v-model.number="item.amount" 
                                  @input="$parent.fn_calculateBomProductsAmount"
                                  placeholder="Rate">
                              </v-flex>
                            </v-layout>

                            <div class="grey-back full-width batch_display_container" :key="'batch_wrapper'+index" v-if="item.batches && item.batches.length">
              
                              <div class="redcolor pt-1 pb-1 pr-3 pl-3 white-back" v-if="item.qtyNotMatched">Item qty not matched with batch qty</div>

                              <v-expansion-panels style="margin: 0!important;">

                                <v-expansion-panel>

                                  <!-- <div slot="header" light-opacity-color font16 class="pt-0 pb-0">{{ item.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</div> -->
                                  <v-expansion-panel-header>
                                      <template>
                                          <v-subheader dense class="pa-0">{{ item.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</v-subheader>
                                      </template>
                                  </v-expansion-panel-header>
                                  
                                  <v-expansion-panel-content>
                                    <v-card flat v-for="(batch, batchIndex) in item.batches" :key="batchIndex">

                                      <v-card-text class="pb-2 pt-2">
                                        <v-layout class="batch_layout ma-0" row wrap>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
                                            <div light-opacity-color>Batch No.</div>
                                            <div>{{ batch.batchNumber }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
                                            <div light-opacity-color>Size</div>
                                            <div>{{ batch.batchSize }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
                                            <div light-opacity-color>MRP</div>
                                            <div>{{ batch.batchMRP }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
                                            <div light-opacity-color>Mfg. Date</div>
                                            <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
                                            <div light-opacity-color>Exp. Date</div>
                                            <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                          </v-flex>
                                          <!-- <v-flex xs4 sm4 md4 mb-2>
                                            <div light-opacity-color>Opening</div>
                                            <div>{{ batch.opening ? batch.opening : 0  }}</div>
                                          </v-flex> -->
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
                                            <div light-opacity-color>Purchase Rate</div>
                                            <div>{{ batch.purchaseRate }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
                                            <div light-opacity-color>Serial Number</div>
                                            <div>{{ batch.field1 }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
                                            <div light-opacity-color>IMEI Number</div>
                                            <div>{{ batch.field2 }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
                                            <div light-opacity-color>Part Number</div>
                                            <div>{{ batch.field3 }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
                                            <div light-opacity-color>Model Number</div>
                                            <div>{{ batch.field4 }}</div>
                                          </v-flex>
                                          <v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.qty)">
                                            <div light-opacity-color>Quantity</div>
                                            <div>{{ batch.productQty }}</div>
                                          </v-flex>
                                          <v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
                                            <v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn icon @click="$parent.fn_removeItemBatch(item, batchIndex)"><v-icon>close</v-icon></v-btn>
                                      </v-card-actions>
                                      <v-divider v-if="item.batches.length - 1 != batchIndex"></v-divider>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>

                              </v-expansion-panels>

                            </div>
                                        <!-- <v-divider v-if="index != $parent.Form.transactionProducts.length - 1"></v-divider> -->
                          </div>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>Items Total</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              &#8377; {{ $root.numberToLocale($parent.Form.amount)  }}
                            </v-list-item-action>
                          </v-list-item>
      
                      </v-list>

                    <v-list two-line class="mt-2 mb-2" nopadding v-if="$parent.Form.transactionProducts && $parent.Form.transactionProducts.length">
                        <v-subheader>Additional Charges 
                          <v-spacer></v-spacer> 

                          <v-menu v-model="$parent.chargesMenu" :max-height="400" :min-width="280" :max-width="280">
                          <template v-slot:activator="{ on, attrs }">

                            <!-- <v-btn full-width outlined light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" v-bind="attrs" v-on="on" text><v-icon font18 style="margin-right:5px">add</v-icon> Charges</v-btn> -->
                            <v-btn color="primary" small text round-borders outlined v-bind="attrs" v-on="on"><v-icon class="primary-color font20 mr-2">add</v-icon> Add</v-btn>
                            
                          </template>

                          <v-list dense nopadding>
                            <v-list-item @click="$parent.fn_menuItemClick('addothercharges')">
                              <v-list-item-content>
                                <v-list-item-title class="primary-color">Create New</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="(item, index) in $parent.charges" :key="index" @click="$parent.fn_getAddonsData(item.itemId)">
                              <v-list-item-content>
                                <v-list-item-title medium-theme-color>{{item.itemName}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        </v-subheader>
                      

                        <template v-for="(item, index) in $parent.Form.transactionAddOns">  
                            <v-divider :key="index+'divider'"></v-divider>                
                            <v-list-item :key="index">
                  <v-list-item-action style="min-width:40px">
                    <v-btn icon @click="$parent.fn_removeAddOns(index)"><v-icon>close</v-icon></v-btn>
                  </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action style="max-width: 100px;">
                                    <v-text-field 
                      class="right-align-textbox"
                      v-model.number="item.value" 
                      @input="item.percentage = null"  
                      type="number" label="" 
                      :prefix="item.nature ? '-' : ''">
                    </v-text-field>
                                </v-list-item-action>
                            </v-list-item>
                            <!-- <v-divider v-if="index != $parent.Form.transactionAddOns.length - 1"></v-divider> -->
                        </template>

              <v-divider></v-divider>

              <!-- <v-list-item v-if="$parent.Form.transactionAddOns && $parent.Form.transactionAddOns.length">
                <v-list-item-content>
                  <v-list-item-title>Charges Total</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  &#8377; {{ $root.numberToLocale(addonsTotal) }}
                </v-list-item-action>
              </v-list-item> -->

              
      
                    </v-list>


                      
                        

                      <v-layout row wrap white-back ma-0 mt-2>

                            <v-flex sm12 md12 xs12 pa-4>
                              <ValidationProvider v-slot="{ errors }" name="Notes" rules="max:255">
                                <v-textarea
                                  rows="2"
                                  label="Notes" 
                                  auto-grow
                                  :counter="255"
                                  v-model="$parent.Form.transactionData.notes"
                                  :error-messages="errors">
                                </v-textarea>
                              </ValidationProvider>
                            </v-flex>
                        </v-layout>

                  </v-form>

                  </ValidationObserver>

                </template>

          </div>

          <!-- <div white-background full-width nopadding style="position:fixed;bottom:0;">
            <v-layout row wrap>
              <template v-if="$parent.totalAmount">
                <template v-if="$parent.batchTotalQty">
                  <v-flex xs6 sm6 md6 pl-3 pt-2 pb-1 style="text-align:left">Batch Total Opening</v-flex>
                      <v-flex xs6 sm6 md6 pr-3 pt-2 pb-1 style="text-align:right">{{$parent.batchTotalQty}} {{$parent.$parent.$parent.Form.selectedUnit ? $parent.$parent.$parent.Form.selectedUnit.itemName : $parent.$parent.$parent.Form.trProducts[0].variants[0].unitName }}</v-flex>
                </template>
                <v-flex xs4 sm4 md4 pl-3 pb-2 style="text-align:left">Total Amount</v-flex>
                    <v-flex xs8 sm8 md8 pr-3 pb-2 style="text-align:right">&#8377; {{$parent.totalAmount ? $root.numberToLocale($parent.totalAmount) : $parent.totalAmount}}</v-flex>
              </template>
              <v-flex xs12 sm12 md12 height48>
                <v-btn color="primary" full-height nomargin block no-round-borders :disabled="$parent.disableBtn" noshadow @click="$parent.fn_checkValidations">Save</v-btn>
              </v-flex>
            </v-layout>
          </div> -->

          <v-card-actions white-back>
              <v-layout row wrap ma-0>
                  <template v-if="$parent.totalAmount">

                    <v-flex xs6 sm6 md6 pt-1 pb-1 light-opacity-color>
                      Item rate as per qty
                    </v-flex>
                    <v-flex xs6 sm6 md6 pt-1 pb-1 right-align light-opacity-color>
                      &#8377; {{ $root.numberToLocale(roundUpto2Decimals($parent.totalAmount/$parent.Form.qty)) }}
                    </v-flex>
                    
                    <v-flex xs4 sm4 md4 pt-2 pb-2 style="text-align:left">Total Amount</v-flex>
                    <v-flex xs8 sm8 md8 pt-2 pb-2 style="text-align:right">&#8377; {{$parent.totalAmount ? $root.numberToLocale($parent.totalAmount) : $parent.totalAmount}}</v-flex>
                  </template>

                  <v-flex xs12 sm12 md12 height48>
                      <v-btn class="save_btn" no-border-radius color="primary" full-height nomargin block no-round-borders noshadow :disabled="$parent.disableOnSave" :key="$parent.saveBtnKey" @click.once="fn_validateForm">Save</v-btn>
                  </v-flex>

              </v-layout>
          </v-card-actions>
                  

          </v-card>

          <v-snackbar v-model="$parent.transactionNumberSnackbar" right vertical :timeout="0">
                Generate new transaction number?

                <template v-slot:action="{ attrs }">

                    <v-btn text @click="$parent.transactionNumberSnackbar = false" color="warning">Close</v-btn>

                    <v-btn class="ml-2" text @click="$parent.fn_getNumberSeries" v-bind="attrs" color="primary">Okay</v-btn>

                </template>
            </v-snackbar>
        </v-dialog>
    </div>
</template>

<script>
// import gstrSubReport from '../print_report_templates/gstr_sub_report'
import { required, numeric, min_value, max } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
// setInteractionMode('eager')

// extend('required', {
//   ...required,
//   message: '{_field_} can not be empty',
// })

extend('min_value', {
    ...min_value,
    message: 'This field must be 0 or more.'
});

extend('max', max)

extend('decimal2', value => {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 2){
    return true;
  }

  return 'This field must be numeric and may contain 2 decimal points.';

});

extend('decimal3', value => {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 3){
    return true;
  }

  return 'This field must be numeric and may contain 3 decimal points.';

});

extend('numeric', {
    ...numeric,
   message: 'This field may only contain numeric characters.' 
});

extend('required', {
  ...required,
  message: 'This field can not be empty',
})

    export default{
        props:['closeDialog'],
        data(){
            return{
                dialog_form: false,
            }
        },
        components:{
            // 'gstr-sub-report':gstrSubReport
            ValidationProvider,
            ValidationObserver
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_form = true;
            },
            closeDialogWeb: function () {
                this.dialog_form = false;
            },
            fn_validateForm: function(){
              this.$parent.disableOnSave = true;
              this.$refs.observer.validate().then((result) => {
                if(result) {
                  this.$parent.fn_checkValidations();
                }
                else{
                  this.$parent.saveBtnKey++;
                  this.$parent.disableOnSave = false;
                  // this.fn_scrollToElement('error--text');
                }
              });
            },
            fn_new: function(){
              this.closeDialogWeb();
              setTimeout(()=>{
                this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/product/items/new', query:{tagId:this.guidWeb(), ls:1}});
              },100);
            },

            fn_unitChange: function(value, item, product){
              let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
              if(currentItemId != value.itemId){
                if(value.itemId == item.secondaryUnitId){
                  product.rate = (product.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
                }
                else{
                  product.rate = (product.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
                  // product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
                }
                // this.tempRate = product.rate;
                product.rate = this.roundUpto2Decimals(product.rate); 
              }
            },
        }
    }
</script>